// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import INbtJsonItem from "./INbtJsonItem";

export default interface IBlockNbtJson {
  id: string;
  Items: INbtJsonItem[];
}
